import Breadcrumb, { type Crumb } from "@/components/feature/Breadcrumb";

type Props = {
  title: string;
  subtitle?: string;
  crumbs: Crumb[];
};

export default function PageHeader({ title, subtitle, crumbs }: Props) {
  return (
    <header className="relative overflow-hidden bg-background-900 pb-10 pt-24 md:pb-14 md:pt-32">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.18]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 85% 20%, oklch(var(--primary-500)) 0%, transparent 45%), radial-gradient(circle at 10% 90%, oklch(var(--accent-500)) 0%, transparent 40%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <Breadcrumb items={crumbs} tone="light" />
        <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-sm leading-7 text-background-300 md:text-base">
            {subtitle}
          </p>
        )}
      </div>
    </header>
  );
}